import React from 'react';

function AuctionSvg() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_519_8450)">
        <path
          d="M21.3084 21.0291H2.7C1.212 21.0291 0 19.8171 0 18.3291V6.92314C0 5.43514 1.212 4.22314 2.7 4.22314H17.5128C18.0096 4.22314 18.4128 4.62634 18.4128 5.12314C18.4128 5.61994 18.0096 6.02314 17.5128 6.02314H2.7C2.2044 6.02314 1.8 6.42754 1.8 6.92314V18.3291C1.8 18.8247 2.2044 19.2291 2.7 19.2291H21.3084C21.804 19.2291 22.2084 18.8247 22.2084 18.3291V5.55514C22.2084 5.05834 22.6116 4.65514 23.1084 4.65514C23.6052 4.65514 24.0084 5.05834 24.0084 5.55514V18.3291C24.0084 19.8171 22.7964 21.0291 21.3084 21.0291Z"
          fill="#00253E"
        />
        <path
          d="M10.6134 13.5271H5.27579C4.77899 13.5271 4.37579 13.1239 4.37579 12.6271C4.37579 12.1303 4.77899 11.7271 5.27579 11.7271H10.6134C11.1102 11.7271 11.5134 12.1303 11.5134 12.6271C11.5134 13.1239 11.1102 13.5271 10.6134 13.5271Z"
          fill="#00253E"
        />
        <path
          d="M10.2222 17.0104H5.27579C4.77899 17.0104 4.37579 16.6072 4.37579 16.1104C4.37579 15.6136 4.77899 15.2104 5.27579 15.2104H10.2222C10.719 15.2104 11.1222 15.6136 11.1222 16.1104C11.1222 16.6072 10.719 17.0104 10.2222 17.0104Z"
          fill="#00253E"
        />
        <path
          d="M14.0598 10.0422H5.27579C4.77899 10.0422 4.37579 9.63899 4.37579 9.14219C4.37579 8.64539 4.77899 8.24219 5.27579 8.24219H14.0598C14.5566 8.24219 14.9598 8.64539 14.9598 9.14219C14.9598 9.63899 14.5566 10.0422 14.0598 10.0422Z"
          fill="#00253E"
        />
        <path
          d="M10.2208 17.032C9.98438 17.032 9.75398 16.9384 9.58478 16.768C9.37838 16.5616 9.28478 16.2676 9.33398 15.9796L9.98678 12.1744C10.018 11.992 10.1068 11.8216 10.2376 11.6908L18.6424 3.28595C19.8244 2.10395 21.8872 2.10515 23.068 3.28595C24.2884 4.50635 24.2884 6.49115 23.068 7.71155L14.6632 16.1164C14.5324 16.2472 14.362 16.336 14.1796 16.3672L10.3744 17.02C10.3228 17.0272 10.2712 17.032 10.2208 17.032ZM11.7124 12.76L11.3236 15.0292L13.5928 14.6404L21.7948 6.43835C22.0456 6.18755 22.1836 5.85395 22.1836 5.49875C22.1836 5.14355 22.0456 4.80995 21.7948 4.55915C21.2932 4.05755 20.4172 4.05755 19.9156 4.55915L11.7124 12.76Z"
          fill="#00253E"
        />
        <path
          d="M21.2475 9.15789C21.0171 9.15789 20.7867 9.07029 20.6115 8.89389L17.4591 5.74149C17.1075 5.38989 17.1075 4.81989 17.4591 4.46829C17.8107 4.11669 18.3807 4.11669 18.7323 4.46829L21.8847 7.62069C22.2363 7.97229 22.2363 8.54229 21.8847 8.89389C21.7083 9.07029 21.4791 9.15789 21.2475 9.15789Z"
          fill="#00253E"
        />
        <path
          d="M14.3512 16.0539C14.1208 16.0539 13.8904 15.9663 13.7152 15.7899L10.5628 12.6375C10.2112 12.2859 10.2112 11.7159 10.5628 11.3643C10.9144 11.0127 11.4844 11.0127 11.836 11.3643L14.9884 14.5167C15.34 14.8683 15.34 15.4383 14.9884 15.7899C14.812 15.9663 14.5828 16.0539 14.3512 16.0539Z"
          fill="#00253E"
        />
      </g>
      <defs>
        <clipPath id="clip0_519_8450">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default AuctionSvg;
